import { BabyForm } from '../../baby-form';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Button } from '@snapi/luxury';
import { Baby } from '@snapi/types';

export interface BabyEditFormProps {
  baby: Baby | null;
  onSave(baby: Baby): Promise<void>;
  onCancel(): void;
}

export function BabyEditForm({ baby, onSave, onCancel }: BabyEditFormProps) {
  const methods = useForm<Baby>();

  useEffect(() => {
    if (baby) {
      methods.reset(baby);
    }
  }, [baby, methods]);

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={methods.handleSubmit(onSave)}
        className="p-3 md:p-5 rounded-[10px] bg-white max-w-[320px] mt-24 sml:mt-10 mb-1 md:mt-[60px]"
      >
        <BabyForm date={baby ? baby.dob : new Date().toString()} />
        <div className="flex gap-2 pt-[22px]">
          <div className="flex flex-1">
            <Button type="submit" size="xs">
              Save
            </Button>
          </div>
          <div className="flex">
            <Button size="xs" type="reset" secondary onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  );
}
